import { SchoolRule } from './schoolManage'

// 3: 付费学校, 4: 付费且添加学校的 , 其余目前没有功能支持
export enum ISchoolOperateType {
  OfficialAuth = 1,
  Paid = 3,
  PaidExport = 4,
}

export interface School {
  id?: number
  province: string
  school_pos: string
  city: string
  district: string
  location: string
  school_id: number
  school_name: string
  school_type: number
  school_length: SchoolRule | null
  operate_type: ISchoolOperateType
  verified: boolean
  verified_start_date: string
  verified_end_date: string
  verify_method: 'student_code' | 'account'
  is_tzy_university_version?: boolean
}
